export enum FeatureFlagsProvider {
  LaunchDarkly = 'launchDarkly',
}

// keep in sync with src/features/projects/enums.ts
export enum AnimationStyleEnum {
  Whiteboard = 'whiteboard',
  TypographyIcon = 'typography_icon',
  IconHeavy = 'icon_heavy',
  Cartoon = 'cartoon',
  FullIllustration = 'full_illustration',
}
